module.exports = __webpack_public_path__ + "img/peter.6bbbacbd.jpg";